import React from 'react'

import { ButtonClean } from '@fourthwall/components'

import * as S from './SpotifyUrlHelp.styled'

export const SpotifyUrlHelp = () => (
  <S.Container>
    <S.Header>How to find your podcast’s Spotify URL:</S.Header>
    <S.List>
      <li>
        Go to{' '}
        <ButtonClean
          label="Spotify’s Podcast page"
          withUnderline
          href="https://open.spotify.com/genre/podcasts-page"
          target="_blank"
        />
      </li>
      <li>Use the Search bar to search for your podcast</li>
      <li>
        Select your podcast in the search results and copy the URL
        <S.Example>Example, https://open.spotify.com/show/7Fj0XEuUQLUqoMZQdsLXqp</S.Example>
      </li>
    </S.List>
  </S.Container>
)
